import { DocumentoAcreditativoPanel } from "@/components/ui/DocumentoAcreditativoPanel";
import {
  type Usuario,
  useBorrarDocumentoUsuario,
  useDescargarDocumentoUsuario,
  useSubirDocumentoUsuario,
} from "@/lib/usuarios";

/**
 * UsuarioDocumentoSection es la sección «Documentación acreditativa» de la ficha del usuario
 * (#435, R13), junto a «Obras y rol». El documento es de la PERSONA y global a todas sus obras
 * (D2); CUALIFICADO y AUTORIZADO no operan sin él. Va contra las rutas GLOBALES de ADMIN
 * (`/usuarios/{id}/documento-acreditativo`); la pantalla de obra usa el mismo panel contra la
 * ruta del miembro.
 */
export function UsuarioDocumentoSection({ usuario }: { usuario: Usuario }) {
  const subir = useSubirDocumentoUsuario();
  const borrar = useBorrarDocumentoUsuario();
  const descargar = useDescargarDocumentoUsuario();

  return (
    <div className="flex flex-col gap-3">
      <h3 className="font-semibold text-slate-900 text-sm">Documentación acreditativa</h3>
      <p className="text-slate-500 text-sm">
        Certificado de formación o cualificación. Sin él, los perfiles Cualificado y Autorizado no
        pueden operar LOTOs en ninguna obra.
      </p>
      <DocumentoAcreditativoPanel
        documento={usuario.documento_acreditativo}
        onSubir={(archivo) => subir.mutateAsync({ idUsuario: usuario.id, archivo })}
        onDescargar={() => descargar.mutateAsync(usuario.id)}
        onBorrar={() => borrar.mutateAsync(usuario.id)}
      />
    </div>
  );
}
